module.exports = __webpack_public_path__ + "img/row_u.97c5a9b8.svg";